module.exports = __webpack_public_path__ + "img/share-cancel.8e78a66b.svg";